{
  "schemaVersion": 1,
  "canonicalOrigin": "https://paperzilla.ai",
  "sourceLocale": "en",
  "urlPolicy": {
    "prefixDefaultLocale": false,
    "sourceLocaleAliasStatus": 308,
    "preserveAliasQuery": true,
    "rootLanguageNegotiation": false,
    "nonSourcePrefixSource": "locale-registry",
    "localizedSlugs": false,
    "unknownLocalePrefix": "not-found",
    "missingLocalizedSurface": "english-fallback",
    "previewRobots": "noindex, nofollow",
    "hreflangPolicy": "complete-live-indexable-only",
    "xDefaultLocale": "en",
    "nativeAppLocalizedPrefixes": "web-only"
  },
  "surfaces": [
    {
      "id": "about",
      "pathname": "/about",
      "owner": "frontend-static",
      "contentClass": "marketing",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": true,
      "dynamic": false
    },
    {
      "id": "agents",
      "pathname": "/agents",
      "owner": "frontend-static",
      "contentClass": "marketing",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": true,
      "dynamic": false
    },
    {
      "id": "auth",
      "pathname": "/auth",
      "owner": "frontend-static",
      "contentClass": "functional",
      "localeEligibility": "excluded",
      "indexable": false,
      "sitemap": false,
      "dynamic": false,
      "reason": "Account and session locale resolution does not use public URL prefixes.",
      "deferredRun": 7
    },
    {
      "id": "banners",
      "pathname": "/banners",
      "owner": "frontend-static",
      "contentClass": "functional",
      "localeEligibility": "excluded",
      "indexable": false,
      "sitemap": false,
      "dynamic": false,
      "reason": "Internal presentation route, not a public localized surface.",
      "deferredRun": 7
    },
    {
      "id": "checkout-cancelled",
      "pathname": "/checkout/cancelled",
      "owner": "frontend-static",
      "contentClass": "functional",
      "localeEligibility": "localized",
      "indexable": false,
      "sitemap": false,
      "dynamic": false
    },
    {
      "id": "checkout-success",
      "pathname": "/checkout/success",
      "owner": "frontend-static",
      "contentClass": "functional",
      "localeEligibility": "localized",
      "indexable": false,
      "sitemap": false,
      "dynamic": false
    },
    {
      "id": "complete-profile",
      "pathname": "/complete-profile",
      "owner": "frontend-static",
      "contentClass": "functional",
      "localeEligibility": "excluded",
      "indexable": false,
      "sitemap": false,
      "dynamic": false,
      "reason": "Account onboarding locale resolution does not use public URL prefixes.",
      "deferredRun": 7
    },
    {
      "id": "digest",
      "pathname": "/digest/:digestId/:slug",
      "owner": "shared",
      "contentClass": "user-content",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": false,
      "dynamic": true,
      "routePattern": "^/digest/[^/]+(?:/[^/]+)?$"
    },
    {
      "id": "digest-paper",
      "pathname": "/digest/:digestId/:slug/p/:paperId/:paperSlug",
      "owner": "shared",
      "contentClass": "scientific-content",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": false,
      "dynamic": true,
      "routePattern": "^/digest/[^/]+(?:/[^/]+)?/p/[^/]+(?:/[^/]+)?$"
    },
    {
      "id": "early-user-offer",
      "pathname": "/early-user-offer",
      "owner": "frontend-static",
      "contentClass": "pricing",
      "localeEligibility": "localized",
      "indexable": false,
      "sitemap": false,
      "dynamic": false
    },
    {
      "id": "email-preferences",
      "pathname": "/email-preferences",
      "owner": "frontend-static",
      "contentClass": "functional",
      "localeEligibility": "excluded",
      "indexable": false,
      "sitemap": false,
      "dynamic": false,
      "reason": "Token-bound account route uses the communication's frozen locale.",
      "deferredRun": 7
    },
    {
      "id": "example-summaries",
      "pathname": "/example-summaries",
      "owner": "frontend-static",
      "contentClass": "marketing",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": false,
      "dynamic": false
    },
    {
      "id": "features",
      "pathname": "/features",
      "owner": "frontend-static",
      "contentClass": "marketing",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": true,
      "dynamic": false
    },
    {
      "id": "field-detail",
      "pathname": "/field/:fieldId/:slug*",
      "owner": "frontend-static",
      "contentClass": "taxonomy",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": false,
      "dynamic": true,
      "routePattern": "^/field/[^/]+(?:/.*)?$"
    },
    {
      "id": "fields",
      "pathname": "/fields",
      "owner": "frontend-static",
      "contentClass": "taxonomy",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": false,
      "dynamic": false
    },
    {
      "id": "forward",
      "pathname": "/forward",
      "owner": "frontend-static",
      "contentClass": "marketing",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": true,
      "dynamic": false
    },
    {
      "id": "home",
      "pathname": "/",
      "owner": "frontend-static",
      "contentClass": "marketing",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": true,
      "dynamic": false
    },
    {
      "id": "incident-post-mortem",
      "pathname": "/incident-post-mortem",
      "owner": "frontend-static",
      "contentClass": "editorial",
      "localeEligibility": "localized",
      "indexable": false,
      "sitemap": false,
      "dynamic": false
    },
    {
      "id": "news-article",
      "pathname": "/news/:slug",
      "owner": "shared",
      "contentClass": "editorial",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": true,
      "dynamic": true,
      "routePattern": "^/news/[^/]+$"
    },
    {
      "id": "news-index",
      "pathname": "/news",
      "owner": "shared",
      "contentClass": "editorial",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": true,
      "dynamic": false
    },
    {
      "id": "newsletter-article",
      "pathname": "/newsletter/:slug",
      "owner": "shared",
      "contentClass": "editorial",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": true,
      "dynamic": true,
      "routePattern": "^/newsletter/[^/]+$"
    },
    {
      "id": "newsletter-index",
      "pathname": "/newsletter",
      "owner": "shared",
      "contentClass": "editorial",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": true,
      "dynamic": false
    },
    {
      "id": "paper",
      "pathname": "/paper/:paperId/:slug*",
      "owner": "shared",
      "contentClass": "scientific-content",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": false,
      "dynamic": true,
      "routePattern": "^/paper/[^/]+(?:/.*)?$"
    },
    {
      "id": "paper-short",
      "pathname": "/p/:paperId/:slug*",
      "owner": "shared",
      "contentClass": "scientific-content",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": false,
      "dynamic": true,
      "routePattern": "^/p/[^/]+(?:/.*)?$"
    },
    {
      "id": "pricing",
      "pathname": "/pricing",
      "owner": "frontend-static",
      "contentClass": "pricing",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": true,
      "dynamic": false
    },
    {
      "id": "privacy",
      "pathname": "/privacy",
      "owner": "frontend-static",
      "contentClass": "legal",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": true,
      "dynamic": false
    },
    {
      "id": "product",
      "pathname": "/product",
      "owner": "frontend-static",
      "contentClass": "marketing",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": true,
      "dynamic": false
    },
    {
      "id": "public-digests",
      "pathname": "/public-digests",
      "owner": "frontend-static",
      "contentClass": "marketing",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": false,
      "dynamic": false
    },
    {
      "id": "research-briefs",
      "pathname": "/research-briefs",
      "owner": "frontend-static",
      "contentClass": "marketing",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": true,
      "dynamic": false
    },
    {
      "id": "subfield-detail",
      "pathname": "/subfield/:fieldId/:fieldSlug/:subfieldId/:subfieldSlug",
      "owner": "shared",
      "contentClass": "taxonomy",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": false,
      "dynamic": true,
      "routePattern": "^/subfield/[^/]+/[^/]+/[^/]+/[^/]+$"
    },
    {
      "id": "summarize",
      "pathname": "/summarize",
      "owner": "frontend-static",
      "contentClass": "marketing",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": false,
      "dynamic": false
    },
    {
      "id": "terms",
      "pathname": "/terms",
      "owner": "frontend-static",
      "contentClass": "legal",
      "localeEligibility": "localized",
      "indexable": true,
      "sitemap": true,
      "dynamic": false
    },
    {
      "id": "trial",
      "pathname": "/trial",
      "owner": "frontend-static",
      "contentClass": "pricing",
      "localeEligibility": "localized",
      "indexable": false,
      "sitemap": false,
      "dynamic": false
    },
    {
      "id": "trial-preview",
      "pathname": "/trial/preview",
      "owner": "frontend-static",
      "contentClass": "pricing",
      "localeEligibility": "localized",
      "indexable": false,
      "sitemap": false,
      "dynamic": false
    },
    {
      "id": "upgrade",
      "pathname": "/upgrade",
      "owner": "frontend-static",
      "contentClass": "pricing",
      "localeEligibility": "localized",
      "indexable": false,
      "sitemap": false,
      "dynamic": false
    }
  ]
}
